import { FulfillmentOrderImageRouteService } from 'common/data';
import { BaseService } from 'core/services';

class FulfillmentOrderImageService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentOrderImageRouteService());
	}

	getImages(fulfillmentOrderId) {
		var url = this.routeService.getImages(fulfillmentOrderId);
		return this.apiClient.get(url);
	}
}

export default FulfillmentOrderImageService;
